import { changelogEntryRefName } from '~/queries/references/changelogEntryRef.query';
import { CTABannerRefName } from '~/queries/references/CTABannerRef.query';
import { imageRefName } from '~/queries/references/imageRef.query';
import { internalLinkRefName } from '~/queries/references/internalLinkRef.query';
import { logoBandRefName } from '~/queries/references/logoBandRef.query';
import { personalizedSectionBuilderRefName } from '~/queries/references/personalizedSectionBuilderRef.query';
import { personRefName } from '~/queries/references/personRef.query';
import { planRefName } from '~/queries/references/planRef.query';
import { referenceCardSelectedPagRefName } from '~/queries/references/referenceCardSelectedPagRef.query';
import { testimonialRefName } from '~/queries/references/testimonialRef.query';
import { scrollingLogoBandRefName } from '~/queries/references/scrollingLogoBandRef.query';

export const sanityRefTypes = [
  internalLinkRefName,
  personalizedSectionBuilderRefName,
  testimonialRefName,
  CTABannerRefName,
  changelogEntryRefName,
  personRefName,
  logoBandRefName,
  planRefName,
  referenceCardSelectedPagRefName,
  imageRefName,
  scrollingLogoBandRefName,
] as const;

// The following function checks for duplicate ref names in the sanityRefTypes array.
const checkForDuplicateRefsName = () => {
  sanityRefTypes.forEach((refType) => {
    if (sanityRefTypes.indexOf(refType) !== sanityRefTypes.lastIndexOf(refType)) {
      throw new Error(`Duplicate ref name found: ${refType}`);
    }
  });
};
checkForDuplicateRefsName();

export type SanityRefTypes = (typeof sanityRefTypes)[number];

export const isValidRefType = (type: string): type is SanityRefTypes => {
  return sanityRefTypes.includes(type as SanityRefTypes);
};
